import { Navigate, Outlet } from "react-router-dom";
import ROUTES from "routes/constant";

const ProtectedRouteLayout = () => {
  const jwt_token = localStorage.getItem("token");

  let auth = { token: jwt_token };
  return auth.token ? <Outlet /> : <Navigate to={ROUTES.AUTH.LOGIN} />;
};
export default ProtectedRouteLayout;
